// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".fd8dba7c39a95cf2364a613427d1955558f91395.chunk.bundle.js";
};